@if ({
  loginInfo: (loginInfo$ | async),
  isLoadingProfiles: (isLoadingProfiles$ | async),
  profiles: (profiles$ | async)
  }; as observables) {
  <div
    class="root-container"
    fxLayout="row"
    fxLayoutAlign="center center"
    >
    <div
      fxFlex="50%"
      fxFlex.lt-sm="95%"
      fxFlex.sm="80%"
      fxFlex.md="70%"
      fxFlex.lg="60%"
      fxFlex.gt-lg="50%"
      class="content-container"
      >
      @if (!showLoader) {
        <button
          mat-icon-button
          id="backButton"
          class="upperButton"
          type="button"
          [disabled]="observables.isLoadingProfiles || isApplyingProfile"
          (click)="cancel()"
          aria-label="Zurück"
          matTooltip="Zurück"
          >
          <mat-icon [svgIcon]="res.svgName('ProfileSelectionBack-Image')" class="upperButtonIcon"></mat-icon>
        </button>
      }
      <div fxLayout="row" fxLayoutAlign="center center">
        @if (observables.loginInfo && !observables.loginInfo.isAnonymous) {
          <div class="titleText">
            {{ observables.loginInfo.displayName }}
          </div>
        }
      </div>
      @if (!showLoader) {
        <div class="introText">Profil auswählen:</div>
      }
      @if (showLoader) {
        <div class="introText" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <span>Profil ausgewählt:</span>
          <div>{{ selectedProfilesName }}</div>
        </div>
      }
      <div class="profiles-container">
        @if (
          !observables.isLoadingProfiles && !isApplyingProfile && !ErrorMessage && observables.profiles) {
          @if (observables.profiles.length) {
            <!-- <mat-selection-list #profilesList [(ngModel)]="selectedProfiles" [multiple]="false" class="list">
            <mat-list-option
              *ngFor="let profile of observables.profiles; last as last"
              [value]="profile"
              [selected]="profile.isCurrent"
              >
              <div [ngClass]="{ 'list-item': true, selected: profile.isCurrent }">
                <label class="profileDesignation">{{ profile.displayText }}</label>
              </div>
            </mat-list-option>
          </mat-selection-list> -->
          <div style="height: 80%">
            <dx-gallery
              [dataSource]="observables.profiles"
              [height]="'100%'"
              width="100%"
              [loop]="false"
              [showIndicator]="true"
              [selectedIndex]="selectedIndex"
              >
              <div *dxTemplate="let profile of 'item'">
                <div
                  (click)="selectProfileAndApply(profile)"
                  fxLayout="column"
                  fxLayoutGap="35px"
                  fxLayoutAlign="center center"
                  class="profileItem"
                  >
                  <!-- <img  *ngIf="!showLoader" class="upperUserImg" src="data:image/png;base64,{{ userInfo?.ImgPortrait }}" /> -->
                  <!-- <mat-icon *ngIf="!showLoader" svgIcon="profile-user" class="upperUserImg"></mat-icon> -->
                  @if (!showLoader) {
                    <mat-icon
                      [svgIcon]="res.svgName('ProfileSelectionUser-Image')"
                      class="upperUserImg"
                    ></mat-icon>
                  }
                  @if (!showLoader) {
                    <label class="profileDesignation">{{ profile.displayText }}</label>
                  }
                </div>
              </div>
            </dx-gallery>
          </div>
        } @else {
          <div class="errorStyleClass">
            <div class="waring">
              <mat-icon class="iconError" svgIcon="auth_error"></mat-icon>
            </div>
            <div class="descriptionError">
              <span>Für den aktuellen Benutzer sind keine Benutzerprofile vorhanden.</span>
              <span>Wende Dich an Deinen Systemadministrator!</span>
            </div>
          </div>
        }
      } @else {
        @if (!isApplyingProfile && !ErrorMessage) {
          <ng-container
          *ngTemplateOutlet="
            progressTemplate;
            context: getProgressTemplateContext(
              'Bitte warte, während die verfügbaren Benutzerprofile geladen werden...'
            )
          "
            >
          </ng-container>
        }
      }
      @if (showLoader) {
        <abcLoader [class]="'login-loader'" [show]="showLoader" id="login-loader"></abcLoader>
      }
      <!-- <ng-container *ngIf="isApplyingProfile && !ErrorMessage; then applyingProfileTemplate"></ng-container> -->
      <!-- <div *ngIf="ErrorMessage" class="errorStyleClass {{ errorClass ? ' ' + errorClass : '' }}">
      <div class="waring">
        <mat-icon ngClass="iconError" ngClass.lt-sm="small" svgIcon="auth_error"></mat-icon>
      </div>
      <div class="msgError">Fehler bei der Profilauswahl.</div>
      <div class="descriptionError" [title]="ErrorMessage">
        <span>Wende Dich an Deinen Systemadministrator!</span>
      </div>
    </div> -->
  </div>
  <!-- Bottom Navigation -->
  <div
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10px"
    class="bottom-nav-panel"
    >
    <!-- <button
    mat-stroked-button
    id="refreshButton"
    ngClass="bottomButton"
    ngClass.lt-sm="bottomButton small"
    type="button"
    [disabled]="observables.isLoadingProfiles || isApplyingProfile"
    (click)="refresh()"
    aria-label="Profile neu laden"
    matTooltip="Profile neu laden"
    >
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
      <span>LISTE&nbsp;AKTUALISIEREN</span>
      <mat-icon svgIcon="profile-refresh" class="bottomButtonIcon"></mat-icon>
    </div>
  </button> -->
  <!-- <button
  mat-raised-button
  id="selectButton"
  ngClass="bottomButton"
  ngClass.lt-sm="bottomButton small"
  type="button"
        [disabled]="
          observables.isLoadingProfiles || isApplyingProfile || selectedProfiles == null || selectedProfiles.length == 0
        "
  (click)="selectProfileAndApply(selectedProfiles[0])"
  aria-label="Profil übernehmen"
  matTooltip="Profil übernehmen"
  >
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <span>PROFIL&nbsp;ÜBERNEHMEN</span>
    <mat-icon matSuffix svgIcon="profile-apply" class="bottomButtonIcon"></mat-icon>
  </div>
</button> -->
<!-- <div>selected: {{selectedProfiles }}</div> -->
</div>
<ng-template #applyingProfileTemplate>
  @if (!ErrorMessage) {
    <ng-container
      *ngTemplateOutlet="progressTemplate; context: getProgressTemplateContext('Benutzerprofil wird übernommen...')"
      >
    </ng-container>
  }
</ng-template>
<ng-template #progressTemplate let-message="message">
  <div class="loaderClass dark">
    <div class="msgStyle dark">{{ message }}</div>
    <abcLoader
      [id]="'loaderProfiles'"
      [class]="'loader'"
      [show]="true"
      [percentageValue]="false"
      [mode]="'indeterminate'"
      >
    </abcLoader>
  </div>
</ng-template>
</div>
</div>
}
